module.exports = __webpack_public_path__ + "img/68_15.83450ab9.png";